import { render } from "./InterestForm.vue?vue&type=template&id=85bb7606"
import script from "./InterestForm.vue?vue&type=script&lang=js"
export * from "./InterestForm.vue?vue&type=script&lang=js"

import "./InterestForm.vue?vue&type=style&index=0&id=85bb7606&lang=scss"

import exportComponent from "/home/avangard/git/toode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__